





































import InvoiceSyncSettingForm from '@accounting/components/others/invoice-sync-setting-form/invoice-sync-setting-form.vue';
import { SaleDay } from '@modules/accounting-integrations/interfaces/pos-session-sync';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-sale-day-mark-as-synced-modal',
  components: {
    'bpc-invoice-sync-setting-form': InvoiceSyncSettingForm,
  },
})
export default class SaleDaySyncModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly value: boolean;
  @Prop({ type: Object, required: true })
  readonly saleDay: SaleDay;
  @Prop({ type: String, required: true })
  readonly saleDayType: 'pos' | 'online';

  // DATA
  loading: boolean = false;

  get showModal(): boolean {
    return this.value;
  }

  set showModal(val: boolean) {
    this.$emit('input', val);
  }

  mounted() {
    this.loading = false;
  }

  // METHODS
  onCloseModal() {
    this.$emit('close-modal');
  }
  async onConfirmMarkAsSynced() {
    if (this.loading) {
      return;
    }

    this.loading = true;

    const url = this.$bpcApiRouteHelper.getApiPath(
      `sales-synchronization/${this.saleDayType}/mark-as-synced`,
    );
    const body = {
      fromSaleDayIdAndBefore: this.saleDay.id,
    };

    try {
      await this.$bpcApi.post(url, body).toPromise();
      this.$bpcMessage.showSuccessMessage({
        text: 'accounting_integrations.sale_day_mark_as_synced_success',
      });
      this.showModal = false;
      this.$emit('mark-as-synced-success', this.saleDay);
      this.loading = false;
    } catch (error) {
      this.$bpcMessage.showErrorMessage({
        text: 'accounting_integrations.sale_day_mark_as_synced_error',
      });
      this.loading = false;
    }
  }

  @Watch('showModal')
  onShowModal() {
    if (this.showModal) {
      this.loading = false;
    }
  }
}
